<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">Termostati</v-card-title>
    <v-card-text>
      <v-row v-if="!loading" class="pa-0 ma-0">
        <v-col cols="2">Nome</v-col>
        <v-col cols="1">T. Now</v-col>
        <v-col cols="1">Max</v-col>
        <v-col cols="1">Min</v-col>
        <v-col cols="1">Avg</v-col>
        <v-col cols="1">T. Bruciat.</v-col>
        <v-col cols="1">Consumo</v-col>
        <v-col cols="1">SetPoint</v-col>
        <v-col cols="1">Allarme</v-col>
      </v-row>
      <v-row v-else justify="center" align="center">
        <v-progress-circular
          indeterminate
          width="1"
          color="green"
        ></v-progress-circular>
      </v-row>
      <v-divider></v-divider>
      <v-subheader>Esterno</v-subheader>
      <template v-if="ext_therms.length === 0">
        <v-row justify="center" align="center" class="pa-0 ma-0">
          <v-col cols="12" class="text-center grey--text text--lighten-1"
            >Nessun termostato esterno configurato</v-col
          >
        </v-row>
      </template>
      <template v-else>
        <template v-for="therm in ext_therms">
          <ThermExtDesktopElement :therm="therm" :key="therm.id" />
        </template>
      </template>
      <v-divider class="my-2"></v-divider>
      <v-subheader>Serre</v-subheader>
      <template v-for="therm in therms">
        <ThermDesktopElement :therm="therm" :key="therm.id" />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import ThermDesktopElement from "./therm_desktop_element.vue";
import ThermExtDesktopElement from "./therm_ext_desktop_element.vue";
import therm_main_mixin from "../mixin/therm_main_mixin";
export default {
  components: {
    ThermDesktopElement,
    ThermExtDesktopElement,
  },
  data() {
    return {
      loading: false,
    };
  },
  mixins: [therm_main_mixin],
};
</script>
